import queryString from 'query-string';
import http from '.';
import { apiAdmins, apiSetting } from './apiRouter';

const getListUser = (body) => {
  const params = queryString.stringify(body);
  return http.get(`${apiAdmins}?${params}`);
};

const register = (body) => http.post(apiAdmins, body);

const getDetail = (id) => {
  return http.get(`${apiAdmins}/${id}`);
};

const update = (id, bodyData) => {
  return http.patch(`${apiAdmins}/${id}`, bodyData);
};

const deleteUser = (body) => http.delete(apiAdmins, { data: body });

const changeStatus = (id, bodyData) => {
  return http.patch(`${apiAdmins}/${id}/status`, bodyData);
};

const savingFestival = (bodyData) => {
  return http.post(apiSetting, bodyData);
};

const detailFestival = (bodyData) => {
  return http.get(apiSetting, {
    params: bodyData,
  });
};

const AdminServices = {
  getListUser,
  register,
  getDetail,
  update,
  deleteUser,
  changeStatus,
  savingFestival,
  detailFestival,
};

export default AdminServices;
